interface LoadingSkeletonProps {
  type?: 'card' | 'row' | 'banner' | 'detail';
  count?: number;
}

export default function LoadingSkeleton({ type = 'card', count = 1 }: LoadingSkeletonProps) {
  if (type === 'banner') {
    return (
      <div className="relative h-[70vh] sm:h-[80vh] lg:h-[90vh] shimmer">
        <div className="absolute bottom-0 left-0 right-0 p-12">
          <div className="space-y-4 max-w-xl">
            <div className="h-12 w-3/4 bg-white/10 rounded" />
            <div className="h-4 w-24 bg-white/10 rounded" />
            <div className="h-20 w-full bg-white/10 rounded" />
            <div className="flex gap-3">
              <div className="h-12 w-32 bg-white/10 rounded-lg" />
              <div className="h-12 w-32 bg-white/10 rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'row') {
    return (
      <div className="py-6 px-4 sm:px-6 lg:px-12">
        <div className="h-8 w-48 bg-white/10 rounded mb-4" />
        <div className="flex gap-3 overflow-hidden">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="flex-shrink-0 w-40 sm:w-44">
              <div className="aspect-[2/3] shimmer rounded-lg" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'detail') {
    return (
      <div className="pt-16">
        <div className="h-[50vh] shimmer" />
        <div className="max-w-7xl mx-auto px-4 py-8 space-y-6">
          <div className="h-10 w-1/3 bg-white/10 rounded" />
          <div className="h-6 w-1/4 bg-white/10 rounded" />
          <div className="h-32 w-full bg-white/10 rounded" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-3 flex-wrap">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="w-40 sm:w-44">
          <div className="aspect-[2/3] shimmer rounded-lg" />
          <div className="mt-2 h-4 w-3/4 bg-white/10 rounded" />
        </div>
      ))}
    </div>
  );
}
